//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { EXISTENCE_USER_CHECK_URL } from '@api/staff.service'

import {
  receiveResource, createResource,
} from '@resource/resource'

import cancellablePromiseProxy from '@aspectus/cancellable-promise-proxy';

export default {
  name: 'NewUser',
  props: ['fields', 'order'],
  data() {
    return {
      authUser: window.authent,
      city: '',
      form_fields: [
        {
          name: 'first_name',
          cols: '12 6-md',
          label: this._('Ваше имя'),
          rules: 'required|onlyCyrillic',
        },
        {
          name: 'last_name',
          cols: '12 6-md',
          label: this._('Ваш фамилия'),
          rules: 'required|onlyCyrillic',
        },
        {
          name: 'middle_name',
          cols: '12 6-md',
          label: this._('Отчество получателя'),
          rules: 'required|onlyCyrillic',
        },
        {
          name: 'email',
          cols: '12 6-md',
          label: this._('Электронная почта'),
          rules: 'required|email',
          events: {
            input: $event => this.checkUser($event, 'email'),
          },
        },
        {
          name: 'phone',
          cols: '12 6-md',
          label: this._('Номер телефона'),
          rules: 'required|phone',
          mask: this.defaultPhoneMask,
          events: {
            input: $event => this.checkUser($event, 'phone'),
          },
        },
        // {
        //   name: 'city',
        //   cols: '12 6-md 4-fhd',
        //   label: this._('Введите населенный пункт Украины *'),
        //   tag: 'city-change-element',
        //   event: city => this.$emit('city:change', city),
        // },
      ],
      form: {
        first_name: this.fields.first_name,
        last_name: this.fields.last_name,
        middle_name: this.fields.middle_name,
        email: this.fields.email,
        phone: this.fields.phone,
        register: false,
      },
      offer: window.offer,
      rules: window.rules,
      currentRequest: null,
      isLoad: false,
      exists: false,
    }
  },

  watch: {
    'order.city': {
      handler(nval) {
        console.log('object', nval);
        this.city = nval
        this.form.city = nval
      },
      deep: true,
    },
    fields: {
      handler() {
        Object.keys(this.form).forEach(key => {
          this.form[key] = this.fields[key]
        })
        this.$emit('update', this.form)
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    async checkUser(value, key) {
      if (this.authUser) return
      this.$emit('validate', this.exists)
      this.$nextTick(async () => {
        await (this.$refs[key][0].$parent.validate())
        if (!this.$refs[key][0].$options.parent.flags.valid || !value) return
        this.exists = false
        this.isLoad = true

        const data = {}
        if (this.$refs.phone[0].$parent.flags.valid) data.phone = this.form.phone
        if (this.$refs.email[0].$parent.flags.valid) data.email = this.form.email

        if (this.currentRequest) this.currentRequest.cancel()
        const cancelController = new AbortController();
        const base = receiveResource.config('signal', cancelController.signal)
        const executer = createResource(EXISTENCE_USER_CHECK_URL, base)
        this.currentRequest = cancellablePromiseProxy(
          new Promise((resolve, reject) => {
            executer.execute(data)
              .then(resolve, reject);
          }),
          { cancelController }
        ).then(({ data: { exists } }) => {
          this.isLoad = false
          this.exists = exists
          if (this.exists) {
            this.form.register = false
            this.$emit('update', this.form)
          }
          this.$emit('validate', this.exists)
        }, () => {
          this.isLoad = false
          this.exists = false
          this.$emit('validate', this.exists)
        })
      })
    },
  },
}
